import { getActionPlanHistogramData } from "../../getActionPlanHistogramData";
import { FoodsIcon, HistogramComparisonChart, WhiteBox } from "@foodpilot/foods";
import { Button, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { ActionPlanCampaigns } from "src/api/client-api/company/overview/useOrganizationOverviewOneSsq.tsx";
import { useCompanyMetadata } from "src/context/Company/Metadata/useCompanyMetadata";
import { URLHandler } from "src/services/URLHandler";
import { ScoreImprovement } from "src/types";

type HistogramBoxProps = {
    ssqId: number;
    actionPlanCampaigns: ActionPlanCampaigns;
    unit: string;
    improvementType: ScoreImprovement | undefined;
};
export const HistogramBox = (props: HistogramBoxProps) => {
    const { actionPlanCampaigns, unit, ssqId, improvementType } = props;
    const theme = useTheme();
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const { company } = useCompanyMetadata();

    const histogramData = getActionPlanHistogramData({ ...actionPlanCampaigns, isMobile });

    return (
        <WhiteBox
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                padding: isMobile ? theme.spacing(2) : theme.spacing(4),
                gap: isMobile ? theme.spacing(2) : theme.spacing(4),
                justifyContent: "space-between",
            }}
        >
            <HistogramComparisonChart
                data={histogramData}
                unit={unit}
                improvementType={improvementType}
                chartHeight={isMobile ? 250 : 300}
                chartStyling={
                    isMobile ?
                        {
                            margin: {
                                top: 40,
                                right: 10,
                                left: 10,
                                bottom: 10,
                            },
                        }
                    :   undefined
                }
            />
            <Link
                to={URLHandler.company.actions.trajectoryBarChart(company.id, ssqId)}
                style={{
                    display: "block",
                }}
            >
                <Button
                    variant="ternary"
                    startIcon={<FoodsIcon size={2} icon={"graph"} />}
                    sx={{
                        width: "100%",
                        ...theme.typography["big-bold"],
                    }}
                >
                    {isMobile ?
                        t("action_plan.go_to_trajectory_short", "See trajectory")
                    :   t("action_plan.go_to_trajectory", "See details of my trajectory")}
                </Button>
            </Link>
        </WhiteBox>
    );
};
